import { render, staticRenderFns } from "./ForwardingItemMoreOptionsModal.vue?vue&type=template&id=85fec77c&scoped=true&"
import script from "./ForwardingItemMoreOptionsModal.vue?vue&type=script&lang=js&"
export * from "./ForwardingItemMoreOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fec77c",
  null
  
)

export default component.exports